import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import Footer from '../../../../../components/footer'
import Head from '../../../../../components/head';
import FormCad from '../../../../../components/auth/saude/documentos/form_cad'


function CadastrarDocumentoSaudeScreen() {

    return (
        <Fragment>
            <Head titulo="Cadastrar Documento da Secretaria Municipal de Saúde" />
            <HeaderLogged />
            <Container>
               <FormCad />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CadastrarDocumentoSaudeScreen;